@import 'styles/variables';

.spin {
  display: block;
  margin: map-get($spacers, 3) auto;
}
